import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Modal } from 'bootstrap';
import { debounceTime, skip } from 'rxjs';
import { loadSocietiesFailure } from 'src/app/legal-action/state/legal.action';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-add-arbitratoin-data',
  templateUrl: './add-arbitratoin-data.component.html',
  styleUrls: ['./add-arbitratoin-data.component.scss']
})
export class AddArbitratoinDataComponent {
  UserDetails: any;
  targetForm!: FormGroup;
  blockList: any[] = [];
  financialYears: any[] = [];
  circlesList: any[] = [];
  arbitrationForm!: FormGroup;
  rows: any[] = [];
  currentMonth: any = {};
  // Map month id to object keys
  monthKeyMap: Record<number, string> = {
    1: 'april',
    2: 'may',
    3: 'june',
    4: 'july',
    5: 'august',
    6: 'september',
    7: 'october',
    8: 'november',
    9: 'december',
    10: 'january',
    11: 'february',
    12: 'march'
  };
  monthList = [

    { id: '1', name: 'April' },
    { id: '2', name: 'May' },
    { id: '3', name: 'June' },
    { id: '4', name: 'July' },
    { id: '5', name: 'August' },
    { id: '6', name: 'September' },
    { id: '7', name: 'October' },
    { id: '8', name: 'November' },
    { id: '9', name: 'December' },
    { id: '10', name: 'January' },
    { id: '11', name: 'February' },
    { id: '12', name: 'March' },
  ];

  constructor(private reportService: ReportsService, private authService: AuthService, private fb: FormBuilder, private toastService: ToastService) {

  }

  ngOnInit(): void {

    this.targetForm = this.fb.group({
      financialYear: ['', Validators.required],
      blockOffice: ['', Validators.required],

    });

    this.initForm();
    let user: any = this.authService.currentUserValue;
    this.UserDetails = user;


    const today = new Date();
    const currentMonthYear = today.toISOString().slice(0, 7); // format: "2025-09"



    switch (this.UserDetails?.roleId) {
      case 13:

        this.targetForm.get('blockOffice')?.valueChanges
          .pipe(skip(1)) // ignore the first emit
          .subscribe((val: any) => {
            if (this.targetForm.valid) {
              this.getArbitrationCases();
            }
          });
        break;
      case 1:
        this.targetForm.addControl('circleOffice', new FormControl({
          value: '',
          disabled: false
        }, Validators.required));
        this.getCircle();
        break;
      case 11:
        this.targetForm.controls['blockOffice'].disable();
        this.targetForm.get('blockOffice')?.valueChanges
          .pipe(skip(1)) // ignore the first emit
          .subscribe((val: any) => {
            if (this.targetForm.valid) {
              this.getArbitrationCases();
            }
          });

        break;
      default:
    }

    this.targetForm.valueChanges
      .pipe(debounceTime(300))  // waits 300ms after last change
      .subscribe(values => {
        if (this.targetForm.valid) {
          this.getArbitrationCases();
        }
      });

    this.getTargetCount();
  }
  initForm() {
    const today = new Date();

    const currentMonthYear = today.toISOString().slice(0, 7); // format: "2025-09"

    this.arbitrationForm = this.fb.group({
      financialYear: [{ value: '2025-2026', disabled: true }, Validators.required],
      blockOffice: [{ value: '', disabled: true }, Validators.required],
      dataMonth: [{ value: currentMonthYear, disabled: true }, Validators.required],

      casesAsOnStart: [0, [Validators.required, Validators.min(0)]],
      amountAsOnStart: [{ value: 0, disabled: false }, [Validators.required, Validators.min(0)]],
      freshCases: [0, [Validators.required, Validators.min(0)]],
      freshCasesAmount: [0, [Validators.required, Validators.min(0)]],
      decidedCases: [0, [Validators.required, Validators.min(0)]],
      decidedCasesAmount: [0, [Validators.required, Validators.min(0)]],

      createdBy: [1], // can be set dynamically
      modifiedBy: [1],
      caseDataId: [0],

      pendencyList: this.fb.array([
        this.createPendency('Below 4 months'),
        this.createPendency('4 months to 1 year'),
        this.createPendency('Above 1 year'),
      ]),
    });

  }
  getTargetCount() {
    let obj = {
      // "action": "GetBIDropdownValue",
      "action": (this.UserDetails?.roleId == 1) ? "GetARDropdownValue" : "GetBIDropdownValue",
      "circleId": this.UserDetails?.iCircleId
    }
    this.reportService.GetTargetCount(obj).subscribe(res => {
      if (res) {
        // this.circlesList = res.data.circles;
        if (this.UserDetails?.roleId !== 1) {
          this.blockList = res.data.blocks;
        }

        this.financialYears = res.data.financialYears
        if (this.UserDetails?.roleId == 11) {
          this.targetForm.controls['blockOffice'].setValue(this.UserDetails?.iBlockId);
          this.targetForm.controls['blockOffice'].disable();
        }
      }
    },
      (error: any) => {
      }
    );
  }
  getCircle() {

    this.reportService.getCircle().subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;
        this.circlesList = res.data.circles;



      }
    },
      (error: any) => {
      }
    );
  }

  GetBlock() {


    let obj = {
      // "action": "GetBIDropdownValue",
      "blockId": 0,
      "circleId": this.targetForm.value?.circleOffice
      // "circleId": 0
    }

    this.reportService.GetBlock(obj).subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;

        this.blockList = res.data?.block;
        this.targetForm.controls['blockOffice'].setValue('');

      }
    },
      (error: any) => {
      }
    );
  }
  showAddButton = false;
  getArbitrationCases() {


    if (this.targetForm.valid) {

      // 👉 You can send this.targetForm.value to your API here
      let obj = {
        "caseDataId": 0,
        blockOffice: this.targetForm.getRawValue().blockOffice.toString(),
        "financialYear": this.targetForm.value?.financialYear?.financialYear
      }



      this.reportService.getArbitrationCases(obj).subscribe(res => {
        if (res) {

          this.rows = res?.data

          if (res && res?.data && res?.data.length > 0) {

            let lastRow = res?.data[res?.data.length - 1];

            if (Number(lastRow?.month) != 12 && Number(lastRow?.month) < 12) {

              let fyear = this.targetForm.getRawValue()?.financialYear.financialYear
              let year = (Number(lastRow?.month) <= 9) ? fyear?.split('-')[0] : fyear.split('-')[1]

              this.currentMonth.key = (Number(lastRow?.month) + 1).toString();
              this.currentMonth.name = this.monthKeyMap[(Number(lastRow?.month) + 1)] + ', ' + year;
              this.showAddButton = true
            } else {
              this.showAddButton = false
              this.rows = [];
              this.initForm();

            }
          } else {
            this.rows = [];
            this.initForm();

            this.showAddButton = true;
            this.currentMonth.name = this.monthKeyMap['1'] + ', ' + this.targetForm.value?.financialYear?.startYear
            this.currentMonth.key = '1';
          }
        }
      },
        (error: any) => {
        }
      );
    }
  }


  // Arbitration form 
  createPendency(category: string): FormGroup {
    return this.fb.group({
      pendencyCategory: [category],
      noOfCases: [0, [Validators.required, Validators.min(0)]],
      amount: [0, [Validators.required, Validators.min(0)]],
    });
  }

  get pendencyList(): FormArray {
    return this.arbitrationForm.get('pendencyList') as FormArray;
  }

  onSubmit() {
    if (this.arbitrationForm.valid) {
      // 🔑 getRawValue() ensures disabled fields are included
      const payload = this.arbitrationForm.getRawValue();
      /**
       * payload will look like:
       * {
       *   financialYear: "2025-2026",
       *   blockOffice: "Shimla Urban - Block Office",
       *   dataMonth: "June, 2025",
       *   casesAsOnStart: 0,
       *   amountAsOnStart: 0,
       *   freshCases: ...,
       *   freshCasesAmount: ...,
       *   decidedCases: ...,
       *   decidedCasesAmount: ...,
       *   createdBy: 1,
       *   modifiedBy: 1,
       *   caseDataId: 0,
       *   pendencyList: [
       *     { pendencyCategory: "Below 4 months", noOfCases: 0, amount: 0 },
       *     ...
       *   ]
       * }
       */
      this.reportService.AddArbitrationCases(payload).subscribe(res => {
        if (res) {
          if (res?.status == 200) {
            this.toastService.showSuccess(res.message);

            this.hideViewMore();
            this.getArbitrationCases();
          }

        }
      },
        (error: any) => {
        }
      );

    } else {
      this.arbitrationForm.markAllAsTouched();
    }
  }

  DeleteArbitrationData(id: any) {
    this.reportService.DeleteArbitrationData(id).subscribe(res => {
      if (res) {
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);

          this.hideViewMore();
          this.getArbitrationCases();
        }

      }
    },
      (error: any) => {
      }
    );
  }
  VerifyArbitrationData(id: any) {
    this.reportService.VerifyArbitrationData(id).subscribe((res: any) => {
      if (res) {
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteIndex = 0;
          // this.hideModal();
          this.getArbitrationCases();

        }

      }
    },
      (error: any) => {
      }
    );
  }
  viewModel(event: any) {
    let lastItem
    if (this.rows && this.rows.length > 0) {
      lastItem = this.rows[this.rows.length - 1]
    }

    let Block: any = this.blockList.find(i => i?.iBlockId == this.targetForm.value?.blockOffice)

    this.arbitrationForm.patchValue({
      financialYear: this.targetForm.value?.financialYear?.financialYear,
      blockOffice: this.targetForm.getRawValue()?.blockOffice,
      dataMonth: this.currentMonth.key,
      casesAsOnStart: lastItem ? lastItem?.balance_No : 0,

      amountAsOnStart: lastItem ? lastItem?.balance_Amt : 0
    });
    if (lastItem) {
      this.arbitrationForm.get('amountAsOnStart')?.disable();
      this.arbitrationForm.get('casesAsOnStart')?.disable();

    }
    else {
      this.arbitrationForm.get('amountAsOnStart')?.enable();
      this.arbitrationForm.get('casesAsOnStart')?.enable();



    }



    this.openModal('readMoreModal');
  }
  hideViewMore() {
    this.currentMonth = {};
    this.showAddButton = false;
    this.hideModal('readMoreModal');

    this.arbitrationForm = this.fb.group({
      financialYear: [{ value: '2025-2026', disabled: true }, Validators.required],
      blockOffice: [{ value: 'Shimla Urban - Block Office', disabled: true }, Validators.required],
      dataMonth: [{ value: '', disabled: true }, Validators.required],

      casesAsOnStart: [0, [Validators.required, Validators.min(0)]],
      amountAsOnStart: [0, [Validators.required, Validators.min(0)]],
      freshCases: [null, [Validators.required, Validators.min(0)]],
      freshCasesAmount: [null, [Validators.required, Validators.min(0)]],
      decidedCases: [null, [Validators.required, Validators.min(0)]],
      decidedCasesAmount: [null, [Validators.required, Validators.min(0)]],

      createdBy: [1], // can be set dynamically
      modifiedBy: [1],
      caseDataId: [0],

      pendencyList: this.fb.array([
        this.createPendency('Below 4 months'),
        this.createPendency('4 months to 1 year'),
        this.createPendency('Above 1 year'),
      ]),
    });
  }
  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }
  // Optional: format month into "September, 2025"
  // Map numeric month to name
  getMonthName(month: string | number): string {
    const months = [
      'April', 'May', 'June', 'July', 'August', 'September',
      'October', 'November', 'December', 'January', 'February', 'March',
    ];
    const index = +month - 1;
    return months[index] || 'Unknown';
  }
  editRow(row: any) {

    const caseData = row;
    const headerData = this.targetForm.getRawValue();
    this.arbitrationForm.patchValue({
      financialYear: headerData.financialYear.financialYear,
      blockOffice: headerData.blockOffice,
      dataMonth: caseData.month,

      casesAsOnStart: caseData.overdue_No,
      amountAsOnStart: caseData.overdue_Amt,
      freshCases: caseData.fresh_No,
      freshCasesAmount: caseData.fresh_Amt,
      decidedCases: caseData.decided_No,
      decidedCasesAmount: caseData.decided_Amt,

      createdBy: 1,
      modifiedBy: 1,
      caseDataId: caseData?.caseDataId
    });

    // Patch pendencyList array separately
    const pendencyArray = this.arbitrationForm.get('pendencyList') as FormArray;
    pendencyArray.at(0).patchValue({
      label: 'Below 4 months',
      noOfCases: caseData.pendency_Below4_No,
      amount: caseData.pendency_Below4_Amt
    });
    pendencyArray.at(1).patchValue({
      label: '4 months to 1 year',
      noOfCases: caseData.pendency_4to12_No,
      amount: caseData.pendency_4to12_Amt
    });
    pendencyArray.at(2).patchValue({
      label: 'Above 1 year',
      noOfCases: caseData.pendency_Above1_No,
      amount: caseData.pendency_Above1_Amt
    });
    this.openModal('readMoreModal');
  }
  deleteIndex: any
  setDeleteIndex(index: number) {
    this.deleteIndex = index;
  }

}
